// src/components/forms/fields/TemplateField.tsx
// Otworzony w Krok 3

import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { FormSection } from '../../../types/forms';

interface TemplateFieldProps {
  section: FormSection;
}

export const TemplateField: React.FC<TemplateFieldProps> = ({ section }) => {
  // For now, just render a simple header placeholder
  // TODO: Implement full template rendering in advanced iterations
  
  if (!section.label && !section.description) {
    // This is likely a product info header - render as styled info box
    return (
      <Paper 
        sx={{ 
          p: 2, 
          mb: 3, 
          backgroundColor: '#e3f2fd',
          border: '1px solid #bbdefb'
        }}
      >
        <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
          Produkt: 3000567257
        </Typography>
        <Typography variant="body2" color="primary">
          Zlecenie: 1870054
        </Typography>
        <Typography variant="body2" color="primary">
          T 7*400
        </Typography>
        <Typography variant="body2" color="primary">
          Fish Fingers MSC
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      {section.label && (
        <Typography variant="h6" component="h3" sx={{ mb: 1, color: '#0277BD', fontWeight: 'bold' }}>
          {section.label}
        </Typography>
      )}
      {section.description && (
        <Typography variant="body2" color="text.secondary">
          {section.description}
        </Typography>
      )}
    </Box>
  );
};